import React from 'react';
import { Row, Col, Table , Popover, Loader} from 'kepler';
import ReactHtmlParser from 'react-html-parser';

class DashboardMonthPayoutTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monthwisePayoutData: this.props.monthwisePayoutData ? this.props.monthwisePayoutData : [],
      monthlyPayoutDetails: {},
      pageNo: this.props.pageNo,
      rowInx: ''
    };
  }
  componentWillReceiveProps(nextProps) {
    let oldData = this.state.monthwisePayoutData, // Array of data
      newData = nextProps.monthwisePayoutData,
      pageNo = nextProps.pageNo
    if (parseInt(pageNo) > 1) {
      let combinedData = oldData.concat(newData);
      this.setState({
        monthwisePayoutData: combinedData
      });
    } else if (nextProps.monthwisePayoutData) {
      this.setState({
        monthwisePayoutData: nextProps.monthwisePayoutData
      });
    }
  }
  componentDidMount() {
    let self = this;
    $('table.donations').on('click', 'tr.hasActivityData', function () {
      let clicked = this,
        rowInx = $('tr.hasActivityData').index(clicked),
        toggle = $(clicked).next(".activityDetails").is(":visible"),
        data = {
          _csrf: $("body").attr("data-csrf"),
          payoutDate: $(clicked).find('input.payout_date').val()
        };
      $('.icon', this).toggleClass('icon-arrow-up-small');
      if ($(clicked).attr('class').indexOf('paymentFailed') > 0) {
        return;
      }
      if (!toggle && ($(clicked).attr('class').indexOf('loaded') < 0)) {
        $('#spinnerWrapper').find('.loaderSpin').clone().appendTo($(clicked).find('.icon')).removeClass('hide');
        $(clicked).addClass('loaded');

        $.post("/givingfund/monthlypayoutdetails", data, function (result) {
          $(clicked).find('div.loaderSpin').remove();
          if (result.status === 'OK') {
            $(clicked).parent().addClass('selectedTBody');
            $(clicked).next(".activityDetails").toggle();
            self.setState({
              monthlyPayoutDetails: result.data.payout,
              rowInx: rowInx
            });
          }
        });
      } else if (toggle) {
        $(clicked).parent().removeClass('selectedTBody');
        $(clicked).next(".activityDetails").toggle();
      } else {
        $(clicked).parent().addClass('selectedTBody');
        $(clicked).next(".activityDetails").toggle();
      }
    });

    //Load Partner Program Details
    $(".activityTable").on('click', '.partnerDetail', function (e) {
      if (e.target.classList.contains('icon-tooltip-small')) {
        e.stopPropagation();
        return;
      }
      $(this).toggleClass("selected").next(".programDetails").toggle();
      $(".transactionDescription .icon", this).toggleClass('icon-arrow-up-small');
    });
  }

  render() {
    let dashboardPageMsg = this.props.dashboardPageMsg;
    let appendMonthWisePayout = this.state.monthwisePayoutData[this.state.rowInx] || {};
    appendMonthWisePayout['monthwisePayoutDataList'] = this.state.monthlyPayoutDetails;
    this.state.monthwisePayoutData.monthwisePayoutDataList = this.state.monthwisePayoutData.monthwisePayoutDataList || [];

    let renderMonthWisePayoutTable = this.state.monthwisePayoutData.map(
      (result, index) => {
        result.monthwisePayoutDataList = result.monthwisePayoutDataList || [];
        let payoutMsg = '', showIconClass = '', failedClass = '';
        if (result.payout_status === '0') {
          payoutMsg = (result.payout_mode && result.payout_mode === 'CHEQUE') ? dashboardPageMsg.dashboard.chqPayment : dashboardPageMsg.dashboard.ppPayment,
          showIconClass = 'icon icon-arrow-down-small';
        } else if (result.payout_status === '1') {
          payoutMsg = (result.payout_mode && result.payout_mode === 'CHEQUE') ? dashboardPageMsg.dashboard.chqPaymentFailed : dashboardPageMsg.dashboard.ppPaymentFailed,
          failedClass = 'paymentFailed';
        } else if (result.payout_status === '2') {
          payoutMsg = (result.payout_mode && result.payout_mode === 'CHEQUE') ? dashboardPageMsg.dashboard.chqPaymentDeposited : '',
          showIconClass = 'icon icon-arrow-down-small';
        }
        return (          
          <tbody key={index}>
            <tr className={`activity hasActivityData ${failedClass}`}>
              <td className="date">
                <input type="hidden" className="payout_date" value={result.payout_date} />
                <span className="month">{result.month}</span>
                <span className="day">{result.date}</span>
                <span className="year">{result.year}</span>
              </td>
              <td className="transactionDescription">
                {dashboardPageMsg.dashboard.ppgf.label}
                <i className={showIconClass}></i>
                <span className={`paidMode ${failedClass}`}>{payoutMsg}</span>
              </td>
              <td className="amount">
                <span className="pos">+</span>&nbsp;{result.total_amount}
              </td>
            </tr>
            <tr className="activityDetails">
              <td></td>
              <td colSpan="2" className="detailsWrap">
                {/* Monthly Payout Details*/}
                {result.monthwisePayoutDataList.map((mwPayoutResult, inx) => {

                  return <div className="payoutDetailsTable" key={inx}>
                    <Row className="partnerDetail">
                      <Col sm="2/3" className="transactionDescription">
                        {mwPayoutResult.partner_name}

                        {(() => {
                          let popOver = mwPayoutResult.partner_name;
                          
                          return popOver == 'Refunds and adjustments' ? <Popover placement="auto" content={ReactHtmlParser(dashboardPageMsg.dashboard.popOverContent)}><span className="icon icon-small icon-tooltip-small" aria-hidden="true" /></Popover> : '';
                        })()}

                        <i className="icon icon-arrow-down-small"></i>
                      </Col>
                      <Col sm="1/3" className="amount">
                        {(() => {
                          let amountSign = mwPayoutResult.amount_sign.toString();
                          return amountSign == 'pos' ? <span className="pos">+</span> : <span className="neg">-</span>;
                        })()}

                        {mwPayoutResult.partner_amount}
                      </Col>
                    </Row>
                    <div className="programDetails">
                      {/* Programwise Payout Details*/}
                      {mwPayoutResult.program_monthly_payouts_list.map((mwProgramPayoutResult, mwProgramInx) => {
                        return <Row key={mwProgramInx}>
                          <Col sm="2/3" className="program_desc">
                            {mwProgramPayoutResult.description}
                          </Col>
                          <Col sm="1/3" className="amount">
                            {(() => {
                              let payoutAmountSign = mwProgramPayoutResult.amount_sign.toString();
                              return payoutAmountSign == 'pos' ? <span className="pos">+</span> : <span className="neg">-</span>;
                            })()}
                            {mwProgramPayoutResult.payout_amount}
                          </Col>
                        </Row>
                      })}
                    </div>
                  </div>;
                })}

              </td>
            </tr>
          </tbody>
        );
      }
    );

    return (
      <div>
        <Table className="activityTable donations">
            {renderMonthWisePayoutTable}
        </Table>
        <div id="spinnerWrapper">
          <div className="loaderSpin hide" />
        </div>
      </div>
    );
  }
}
export default DashboardMonthPayoutTable;



// WEBPACK FOOTER //
// ./ppgf/components/dashboardMonthPayoutTable.js